import React from 'react'
import CommonBanner from '../Banner/CommonBanner'
import BannerImg from "../images/HeaderBackground.svg";
import CookieCutterTechnologyAnalysis from './CookieCutterTechnologyAnalysis'

export default function TechnologyAnalysis(props) {
  return (
    <div>
      
      <CommonBanner smalltitle={"AI-Powered"} setHandleReqPop={props.setHandleReqPop} dImage={BannerImg} desc1={"Find emerging technologies, identify startups"} desc={"Newer technologies are emerging everyday. Stay on top of all things tech. Our Technology Analysis solutions are loved by R&D, Technology and CVC teams worldwide."} title={"Technology Analysis"}></CommonBanner>
      <CookieCutterTechnologyAnalysis title={"Technology Analysis"}></CookieCutterTechnologyAnalysis>


    </div>
  )
}
